
define('tpl!taoQtiItem/qtiXmlRenderer/tpl/responses/rule_correct', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <responseElse>\n        <setOutcomeValue identifier=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.feedback)),stack1 == null || stack1 === false ? stack1 : stack1.outcome)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n            <baseValue baseType=\"identifier\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.feedback)),stack1 == null || stack1 === false ? stack1 : stack1['else'])),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</baseValue>\n        </setOutcomeValue>\n    </responseElse>";
  return buffer;
  }

  buffer += "<responseCondition>\n    <responseIf>\n        <match>\n            <variable identifier=\"";
  if (helper = helpers.response) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.response); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n            <correct identifier=\"";
  if (helper = helpers.response) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.response); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n        </match>\n        <setOutcomeValue identifier=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.feedback)),stack1 == null || stack1 === false ? stack1 : stack1.outcome)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n            <baseValue baseType=\"identifier\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.feedback)),stack1 == null || stack1 === false ? stack1 : stack1.then)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</baseValue>\n        </setOutcomeValue>\n    </responseIf>";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.feedback)),stack1 == null || stack1 === false ? stack1 : stack1['else']), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</responseCondition>";
  return buffer;
  });
});

